export enum PasswordStrength {
  VERY_WEAK = 0,
  WEAK = 20,
  GOOD = 40,
  STRONG = 60,
  VERY_STRONG = 85
}
